var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.6 6.223a5.4 5.4 0 1110.8 0 5.4 5.4 0 01-10.8 0z",
    fill: "#F26464"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 3.222a.45.45 0 01.45.45v.9a.45.45 0 11-.9 0v-.9a.45.45 0 01.45-.45zM6 6.222a.45.45 0 01.45.45v2.1a.45.45 0 11-.9 0v-2.1a.45.45 0 01.45-.45z"
  }))));
}
export default SvgInfoCircleRed;